import React, { useCallback, useEffect, useState } from "react";
import FormulaBuilderModal from "./FormulaBuilderModal";

const FormulaInput = (props) => {
  const [formulaValue, setFormulaValue] = useState(props.value || "");

  useEffect(() => {
    setFormulaValue(props.value || "");
  }, [props.value]);

  const handleSave = useCallback(
    (nextValue) => {
      const payload =
        nextValue && typeof nextValue === "object"
          ? nextValue
          : { formula: nextValue };
      const normalizedFormula = (payload.formula || "").trim();
      setFormulaValue(normalizedFormula);

      if (props.onSaveSettings) {
        props.onSaveSettings({
          formula: normalizedFormula,
          field: payload.field,
          roundTo: payload.roundTo,
          commit: payload.commit === true,
        });
      } else {
        if (props.onChange) {
          props.onChange({ target: { value: normalizedFormula } });
        }

        if (props.onBlur) {
          props.onBlur({ target: { value: normalizedFormula } });
        }
      }
    },
    [props.onBlur, props.onChange, props.onSaveSettings]
  );

  return (
    <div className="w-full min-w-0 max-w-full">
      <input type="hidden" name={props.name} value={formulaValue} readOnly />

      <FormulaBuilderModal
        formula={formulaValue}
        targetField={props.targetFieldValue}
        roundTo={props.roundToValue}
        website={props.website}
        onSave={handleSave}
      />
    </div>
  );
};

export default FormulaInput;
